import { useMemo } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const STATUS_COLOR = {
  nouveau: "#4A90A4",   // pine-blue
  contacte: "#C46A4B",  // terracotta
  interesse: "#5E8B6E", // forest
  converti: "#2E5A44",  // pine
  perdu: "#9AA5A0",     // muted
};
const STATUS_LABEL = {
  nouveau: "Nouveau", contacte: "Contacté", interesse: "Intéressé", converti: "Converti", perdu: "Perdu",
};
const ACTIVITY_LABEL = {
  nordic_yoga: "Nordic Yoga", nordic_walking: "Nordic Walking", both: "Les deux", other: "Autre",
};

/**
 * ProspectsMap — Circle markers colored by status. Points without coordinates are skipped.
 */
export default function ProspectsMap({ prospects = [], height = "520px" }) {
  const withCoords = useMemo(() => prospects.filter(p => typeof p.lat === "number" && typeof p.lng === "number"), [prospects]);
  const center = useMemo(() => {
    if (!withCoords.length) return [50.8503, 4.3517]; // Brussels default
    const avgLat = withCoords.reduce((a, p) => a + p.lat, 0) / withCoords.length;
    const avgLng = withCoords.reduce((a, p) => a + p.lng, 0) / withCoords.length;
    return [avgLat, avgLng];
  }, [withCoords]);

  if (!withCoords.length) {
    return (
      <div className="card-warm p-8 text-center text-[var(--muted-text)]" data-testid="prospects-map-empty">
        Aucun prospect géolocalisé. Ajoutez une adresse complète (rue + CP + ville) pour voir ces contacts sur la carte.
      </div>
    );
  }

  return (
    <div className="rounded-2xl overflow-hidden shadow-sm border border-slate-200" style={{ height }} data-testid="prospects-map">
      <MapContainer center={center} zoom={withCoords.length === 1 ? 12 : 8} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {withCoords.map(p => {
          const color = STATUS_COLOR[p.status] || "#5A6B62";
          return (
            <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={9} pathOptions={{ color, fillColor: color, fillOpacity: 0.75, weight: 2 }}>
              <Popup>
                <div style={{ minWidth: 220 }}>
                  <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, fontWeight: 600, color: "#2E5A44" }}>{p.first_name} {p.last_name}</div>
                  <div style={{ fontSize: 11, color: "#7A8F81", marginTop: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>{STATUS_LABEL[p.status] || p.status} · {ACTIVITY_LABEL[p.activity] || p.activity}</div>
                  {p.city && <div style={{ fontSize: 12, color: "#5A6B62", marginTop: 6 }}>{p.postal_code} {p.city}</div>}
                  {p.email && <div style={{ fontSize: 12, color: "#5A6B62" }}>{p.email}</div>}
                  {p.phone && <div style={{ fontSize: 12, color: "#5A6B62" }}>{p.phone}</div>}
                </div>
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}
